import '@filters/filters';
import '@filters/_filters';
import Vuelidate from 'vuelidate';
import moment from 'moment';
import VueSelectSides from "vue-select-sides";

import Vue from 'vue'

declare module 'vue/types/vue' {
  interface Vue {
    $window: any;
    $moment: any;

    $socket: any;
    $disconnect: any;
    $connect: any;
    $env: any;
  }
}

Vue.use(Vuelidate);
// @ts-ignore
Vue.use(VueSelectSides);
Vue.component("vue-select-sides", VueSelectSides);

Vue.prototype.$env = {}
let env : any = window.__env
for (let key in env) {
  const val : any = env[key]
  Vue.prototype.$env[key] = val
}

Vue.prototype.$window = window;
Vue.prototype.$moment = moment;

Vue.config.devtools = true;
